import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Re-export all utility modules
export * from "./formatters";
export * from "./risk-assessment";
export * from "./financial-calculations";
